import React from 'react';
import DOMPurify from 'dompurify';

import { componentTypes } from '@white-nl/instantsearch-components';
import { Image } from '../../../ui/Picture/Picture';
import Picture from '../../../ui/Picture';

export default function Hit({ hit }: componentTypes.HitProps) {
  const {
    title,
    slug,
    faqContent,
  } = hit;

  interface Block {
    id: number;
    type: {
      title: string;
      handle: string;
    };
    text: string;
    image: Image;
  }

  return (
    <div className="accordion-item">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapse-accordion-${slug}`}
        aria-expanded="false"
        aria-controls={`collapse-accordion-${slug}`}
      >
        {title}
      </button>
      <div
        className="accordion-collapse collapse"
        id={`collapse-accordion-${slug}`}
        data-bs-parent="#accordion"
      >
        <div className="accordion-body pb-5">
          {(faqContent || []).map((block: Block) => (
            <div key={block.id} className="mb-3">
              {block.type.handle === 'text' && (
                // eslint-disable-next-line react/no-danger
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(block.text) }} />
              )}
              {block.type.handle === 'image' && (
                <div className={block.image.imageType === 'icon' ? 'hold-img hold-img--icon' : 'hold-img'}>
                  <Picture image={block.image} defaultTransform="xxl-min" loading="lazy" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
